import { render, staticRenderFns } from "./serviceList.vue?vue&type=template&id=04c95550&scoped=true"
import script from "./serviceList.vue?vue&type=script&lang=js"
export * from "./serviceList.vue?vue&type=script&lang=js"
import style0 from "./serviceList.vue?vue&type=style&index=0&id=04c95550&prod&scoped=true&lang=scss"
import style1 from "./serviceList.vue?vue&type=style&index=1&id=04c95550&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c95550",
  null
  
)

export default component.exports